export default build =>
    build.mutation({
        query(payload) {
            console.log("payload in create event name",payload)
            return {
                url: '/school/createPhotoGalleryEventName',
                method: 'POST',
                body: payload,               
            };
        },
        invalidatesTags: ['photogallerybyid'],
    })
